import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IPublicV1NaturalPersonUpdateRequest } from 'shared/repositories/dailyrent/entities/request/PublicV1NaturalPersonUpdateRequest';

import {
  fetchNaturalPersonUpdate,
  TNaturalPersonUpdateRequest,
  TNaturalPersonUpdateResponse,
} from 'shared/repositories/dailyrent/v1/natural-person/update';
import { type Result, Ok, Err } from 'shared/types/result';

import { classifyApiError, IValidationApiError, type IApiError, type TServiceError } from 'shared/utils/apiErrors';

export type TNaturalPersonFieldKey = keyof IPublicV1NaturalPersonUpdateRequest;
export type TNaturalPersonValidationError = IValidationApiError<TNaturalPersonFieldKey>;
export type TUpdateNaturalPersonError = TServiceError<TNaturalPersonValidationError, IApiError>;

export type TUpdateNaturalPersonResult = Result<void, TUpdateNaturalPersonError>;

interface IParams {
  httpApi: IHttpApi;
  parameters: TNaturalPersonUpdateRequest;
  logger: ILogger;
}

export async function updateNaturalPersonData(params: IParams): Promise<TUpdateNaturalPersonResult> {
  const { logger, httpApi, parameters } = params;

  try {
    const { response, statusCode } = (await fetchNaturalPersonUpdate({
      httpApi,
      parameters,
    })) as TNaturalPersonUpdateResponse;

    if (statusCode !== 200) {
      return Err(classifyApiError(response));
    }

    return Ok(response);
  } catch (error) {
    logger.error(error);

    return Err({ type: 'unknown' });
  }
}
